<template>
  <hel-module title="今天需要处理" :class="scope.clsPrefix" v-loading="loading">
    <div class="tl-subtitle">五个智能体的待办汇总：P0全部 + 3天内到期的P1</div>
    <div class="tl-scroll">
      <div class="tl-item" v-for="item in list" :key="item.id">
        <div class="tl-main">
          <div class="tl-title-row">
            <span :class="['tl-tag', item.priority === 'P0' ? 'tl-tag-p0' : 'tl-tag-p1']">
              {{ item.priority }}
            </span>
            <span class="tl-title">{{ item.title }}</span>
          </div>
          <div class="tl-desc">{{ item.desc }}</div>
          <div class="tl-source">
            来源：{{ item.source }} · 要求完成 {{ item.deadline }}
          </div>
        </div>
        <button type="button" class="tl-assign" @click="handleAssign(item)">
          交给{{ item.assignee }} →
        </button>
      </div>
      <div v-if="!list.length" class="tl-empty">暂无数据</div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import { getSalesTodayTasks } from '@/api/sales'

export default {
  name: 'SalesTodayTasks',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-sales-today-tasks'
      },
      list: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // assignee 与问数问题原文的对应关系
    getAssignQuestion(item) {
      const questionMap = {
        商机报价:
          '请处理这条询价并给出完整报价方案：先说明推进步骤与所需资料，完成成本核算并给出成本构成，校验产能与交期给出可承诺交期，按客户分层给出报价方案并说明净利率是否达标，最后给出报价单草稿。',
        客户洞察:
          '请分析这个客户的经营情况：说明客户价值评级与依据，盘点在跟商机的阶段与赢率分布，指出最值得投入的商机和最需要补齐的信息，并给出接下来的动作与负责角色。',
        履约交付:
          '请分析这张订单的履约情况：判断能否按承诺交期交付，定位最需要先处理的节点或物料，给出到交期前的跟进安排，并区分系统动作与人工动作。',
        合同智控:
          '请分析这份合同当前是否可以继续推进：检查主体、商务、财税、法务与交付条款，指出需要修改的条款及修改建议，并说明需要人工或外部审批确认的事项。',
        投标作战:
          '请分析这个投标项目的进展与风险：指出必须先处理的资格与废标风险项，核对评分点响应是否落到标书正文，并给出到投标截止前的排期建议。'
      }
      const question = questionMap[item.assignee] || ''
      if (!question) {
        return ''
      }
      // 客户简称/待办编号与问题分行展示
      return `${item.shortName}/${item.id}\n${question}`
    },
    // 点击「交给XX」打开智能问数抽屉，携带问题原文由宿主直发
    handleAssign(item) {
      const content = this.getAssignQuestion(item)
      if (!content) {
        return
      }
      this.$emit('smart-analysis', {
        type: 'salesKpi',
        content,
        name: item.title
      })
    },
    async fetchTaskList() {
      const res = await getSalesTodayTasks()
      if (!res || res.code !== 200 || !Array.isArray(res.data)) {
        return []
      }
      return res.data
    },
    async fetchData() {
      this.loading = true
      try {
        const res = await this.fetchTaskList()
        this.list = Array.isArray(res) ? res : []
      } catch (error) {
        console.error('获取今日待办数据失败:', error)
        this.list = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-sales-today-tasks";

.tl-item {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  background: #f7f8fc;
  border-radius: 8px;
  padding: 10px 12px 10px 16px;
  margin-bottom: 8px;
  &::before {
    content: '';
    position: absolute;
    left: 6px;
    top: 10px;
    bottom: 10px;
    width: 3px;
    border-radius: 2px;
    background: #4a5ff3;
  }
  &:last-child {
    margin-bottom: 0;
  }
}

.tl-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tl-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tl-tag {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  color: #ffffff;
  line-height: 16px;
}

.tl-tag-p0 {
  background: #f44f4f;
}

.tl-tag-p1 {
  background: #f79a3e;
}

.tl-title {
  font-size: 13px;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tl-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular;
  color: #606266;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tl-source {
  font-size: 12px;
  font-family: PingFangSC-Regular;
  color: #98a1b2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tl-assign {
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  color: #4a5ff3;
  white-space: nowrap;
  cursor: pointer;
}

.tl-empty {
  padding: 16px 4px;
  font-size: 12px;
  color: #98a1b2;
}

.#{$class-prefix} {
  .tl-subtitle {
    font-size: 12px;
    font-family: PingFangSC-Regular;
    color: #909399;
    margin-bottom: 8px;
  }
  .tl-scroll {
    height: calc(100% - 26px);
    overflow: auto;
  }
}
</style>
